import React from 'react'
import {useHistory} from "react-router-dom"

export function EnquiryDetails() {
    const history = useHistory()

    const getDetails = history.location.state
    const cargoDetail = getDetails && getDetails.quotes && getDetails.quotes[0].quote_air
    // console.log("cargoDetail===>>", cargoDetail.request_data.items)

    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12 my-4">
                                <h3 className="mb-3 d-flex align-items-center"><b>Enq ID - {getDetails && getDetails._id && getDetails._id.user_id} &nbsp;  </b> <img className="shareicon" src="/admin/assets/images/share_icon.svg" height="20" alt='share-icon' /></h3>
                                <p className="text-muted">Advance paid - 0.00 AED</p>
                            </div>
                            {/* 
              <HorizontalTimeline
                 index={value}
                 indexClick={(index) =>
              {
              setValue({ value: index, previous: value });
              }}
              values={VALUES} /> */}
                            {/* <div className="col-md-12  d-flex align-items-center" >
                                <div id="trackingSec" className="trackingSec">
                                    <div className="overflow-auto">
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Booking Confirmed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Ship at warehouse</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Departed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Arrived</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Delivered</span>
                                        </div>

                                    </div>
                                </div>
                            </div> */}
                            <div className="d-flex places col-lg-6 col-12 mx-auto border align-items-center justify-content-between mb-4">
                                <div className="fromPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>From</small><br />
                                    {cargoDetail && cargoDetail[0].request_data && cargoDetail[0].request_data.origin_city}</h5>
                                </div>
                                <div className="path flex-grow-1 text-center">
                                    <span>Courier, Door to Door</span>
                                </div>
                                <div className="toPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>To</small><br />
                                    {cargoDetail && cargoDetail[0].request_data && cargoDetail[0].request_data.destination_city}</h5>
                                </div>
                            </div>


                            <div className="col-md-12">


                                <div className="row">
                                    <div className="col-lg-4 col-md-6 mb-3">
                                        <div className="card h-100 p-3">
                                            {/* <h4>Customer Info.</h4><hr /> */}

                                            <div className="text-center ">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                                                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                                    </svg>
                                                </div>
                                                <h5>Customer Name</h5>
                                                <p className="mb-0">loremipsum@gmail.com</p>
                                                <p className="mb-0">919898959898</p>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>

                                                    <tr>
                                                        <td className="py-1">End Customer Type - </td>
                                                        <td className="py-1">Tourist/ Resident</td>
                                                    </tr>
                                                   
                                                    <tr>
                                                        <td className="py-1">Inquiry Category - </td>
                                                        <td className="py-1">lorem</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Inquiry Date - </td>
                                                        <td className="py-1">4 May, 2021</td>
                                                    </tr>
                                                   
                                                   
                                                  
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-3">
                                        <div className="card h-100 p-3">
                                            <div className="text-center">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shop" viewBox="0 0 16 16">
                                                        <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z" />
                                                    </svg>
                                                </div>
                                                <h5>Retailer Name</h5>
                                                <p className="mb-0">Service - Door To Door</p>
                                                <p className="mb-0">Quotation No - 989569898</p>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>
                                                   
                                                    {/* <tr>
                                                        <td className="py-1"> Confirmed- </td>
                                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Yes</span> </td>
                                                    </tr> */}

<tr>
                                                        <td className="py-1">Quotation Amt - </td>
                                                        <td className="py-1">4547</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Quotation status - </td>
                                                        <td> <span className="badge rounded-pill font-size-12 pointer bg-success">Pending</span> </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Total Value of Goods - </td>
                                                        <td className="py-1">898</td>
                                                    </tr>
                                                   
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-3">
                                        <div className="card h-100 p-3">
                                            <div className="text-center">
                                                <div className="iconImg mx-auto my-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-truck" viewBox="0 0 16 16">
                                                        <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                    </svg>
                                                </div>
                                                <h5>Shipment Info.</h5>
                                                <p className="mb-0">Destination - {cargoDetail && cargoDetail.request_data && cargoDetail.request_data.destination_city}</p>
                                                <p className="mb-0">Tentative Shipping Date - 19,June</p>
                                            </div>
                                            <hr />
                                            <table width="100%">
                                                <tbody>

                                                   
                                                    <tr>
                                                        <td className="py-1">Promo / Referral Code - </td>
                                                        <td className="py-1">59898</td>

                                                    </tr>
                                                  
                                                    <tr>
                                                        <td className="py-1">Follow Up Date - </td>
                                                        <td className="py-1">14 May, 2021</td>

                                                    </tr> 
                                                    <tr>
                                                        <td className="py-1">Current Shipment Status - </td>
                                                        <td className="py-1">4 May, 2021</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Updated Shipment Status - </td>
                                                        <td className="py-1">31 May, 2021</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <ul className="nav mb-3 mt-0 tablist profiletab" id="pills-tab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a className="nav-link active" id="pills-instructions-tab" data-bs-toggle="pill" data-bs-target="#pillsinstructions" type="button" >
                                                    <img className="showonmob" height="20" src="/admin/assets/images/document.svg" alt='document' />
                                                    <span className="showondesk">Cargo Details</span>
                                                </a>
                                            </li>


                                        </ul>
                                    </div>
                                    <div className="tab-content " id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pillsinstructions" role="tabpanel">
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered text-center">
                                                        <thead>
                                                            <tr className="lh-sm">
                                                            <th rowspan="2"> Item Code</th>
                                                            <th rowspan="2">Item Description</th>
                                                            <th rowspan="2">No. of Packages</th>
                                                            <th rowspan="2">Weight </th>
                                                            <th colspan="3">Dimension</th>
                                                            <th rowspan="2">Total Volume</th>
                                                            <th rowspan="2">Total Weight</th>
                                                            <th rowspan="2">Comments</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Length</th>
                                                                <th>Width</th>
                                                                <th>Height</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            cargoDetail && cargoDetail[0].request_data.items.length >=0 && 
                                                            cargoDetail[0].request_data.items.map((item, key)=>{
                                                                return (
                                                                    <tr key={key}>
                                                                    <td> 98756 </td>
                                                                    <td> {item.item_description} </td>
                                                                    <td> {item.no_of_pkgs} </td>
                                                                    <td> {item.dimension.length} </td>


                                                                    {/* <td> <span> {item.dimension.length} </span> 
                                                                    &nbsp; <span> {item.dimension.width} </span>
                                                                    &nbsp; <span> {item.dimension.height} </span>
                                                                    </td> */}
                                                                    
                                                                    <td>{item.dimension.length}</td>
                                                                    <td>{item.dimension.width}</td>
                                                                    <td>{item.dimension.height}</td>

                                                                    <td> {item.total_volume_CBM} </td>
                                                                    <td> {item.total_weight_KG} </td>
                                                                    <td>  while creating the fields, use a remove button with each field </td>
                                                            </tr>
                                                                )
                                                            }) 
                                                        }
                                                           
                                                            
                                                            {/* <tr>
                                                                <td> 98756 </td>
                                                                <td> making a primitive quiz app with 3 questions so far </td>
                                                                <td> 127 </td>
                                                                <td> 98kg </td>
                                                                <td> 98cm </td>
                                                                <td> 198kg </td>
                                                                <td> 398kg </td>
                                                                <td>  while creating the fields, use a remove button with each field </td>

                                                            </tr>
                                                            <tr>
                                                                <td> 98756 </td>
                                                                <td> making a primitive quiz app with 3 questions so far </td>
                                                                <td> 127 </td>
                                                                <td> 98kg </td>
                                                                <td> 98cm </td>
                                                                <td> 198kg </td>
                                                                <td> 398kg </td>
                                                                <td> 398kg </td>

                                                            </tr> */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

